export default function initRolloverCards() {
  const cards = document.querySelectorAll('.rollover-card');

  if (cards.length == 0) return;

  function setTextHeight(elem) {
    setTimeout(function() {
      let elemHeight = elem.offsetHeight;
      elem.style.setProperty('--text-height', elemHeight + 'px');
    }, 500);
  }

  cards.forEach(card => {
    const text = card.querySelector('.rollover-card__text');
    setTextHeight(text);
  })

  window.addEventListener('resize', function() {
    cards.forEach(card => {
      const text = card.querySelector('.rollover-card__text');
      setTextHeight(text);
    })
  });
}